module.exports = __webpack_public_path__ + "img/align-right.aaf6d6cf.svg";